/* React base class */
import { Component } from "react"

/* Redux store connection */
import { connect } from "react-redux"

/* Router HOC and shared utilities */
import { withRouter, utils, applySeo } from "../../helpers"

/* Shared UI components */
import { Account, Loading, Network } from "../../components"

/* Icon component */
import Icon from "../../components/Icon"

/* Category icon */
import CatIcon from "../../components/CatIcon"

/* Booking API: list, cancel, reschedule */
import { list, cancel, reschedule as rescheduleApi } from "../../api/Booking"

/* i18n */
import { translate } from "../../translates"

const DOW = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]
const MONTHS = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"]
const TIMES = ["10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00"]

/* Page Bookings */
class Bookings extends Component {

    constructor(props) {
        super(props)

        /* State */
        this.state = {
            loading: true,
            error: false,
            tab: "active",
            items: [],
            detail: null,
            confirm: null,
            reschedule: null,
            rescheduleDay: 0,
            rescheduleTime: null,
            busy: false,
            toast: null
        }
    }

    /* Show a short success message */
    _toast = (message) => {
        this.setState({ toast: message })
        setTimeout(() => this.setState({ toast: null }), 2600)
    }

    componentDidMount = () => {
        /* SEO */
        applySeo({ title: `Мои записи — Bookify`, description: `Ваши предстоящие и прошедшие записи в Bookify.`, path: `/bookings`, robots: `noindex, nofollow` })
        window.scroll(0, 0)
        this.load()
    }

    load = () => {
        this.setState({ loading: true, error: false })
        list(this.props.token, this.state.tab).then((response) => {
            if (response && response.status === 200) {
                this.setState({ items: Array.isArray(response.data) ? response.data : [], loading: false })
            }
            else {
                this.setState({ loading: false, error: true })
            }
        })
    }

    _tab = (tab) => {
        this.setState({ tab }, this.load)
    }

    /* Next 14 days for the reschedule strip */
    _days = () => {
        const days = []
        const now = new Date()
        for (let index = 0; index < 14; index++) {
            const date = new Date(now)
            date.setDate(now.getDate() + index)
            days.push({
                iso: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`,
                dow: DOW[date.getDay()],
                day: date.getDate(),
                mon: MONTHS[date.getMonth()]
            })
        }
        return days
    }

    _openDetail = (booking) => {
        this.setState({ detail: booking })
    }

    _closeDetail = () => {
        this.setState({ detail: null })
    }

    _openReschedule = (booking) => {
        this.setState({ reschedule: booking, detail: null, rescheduleDay: 0, rescheduleTime: null })
    }

    _closeReschedule = () => {
        this.setState({ reschedule: null })
    }

    /* Save the new date and time */
    _saveReschedule = () => {

        /* Fields */
        const { reschedule, rescheduleDay, rescheduleTime, busy } = this.state

        if (busy || !rescheduleTime) {
            return
        }
        const day = this._days()[rescheduleDay]
        this.setState({ busy: true })
        rescheduleApi(this.props.token, reschedule.id, { date: day.iso, time: rescheduleTime }).then((response) => {
            this.setState({ busy: false })
            if (response && response.status === 200) {
                this.setState({ reschedule: null })
                this.load()
                this._toast("Время записи изменено")
            }
        })
    }

    _openCancel = (booking) => {
        this.setState({ confirm: booking, detail: null })
    }

    _closeCancel = () => {
        this.setState({ confirm: null })
    }

    /* Confirm cancellation */
    _confirmCancel = () => {

        /* Fields */
        const { confirm, busy } = this.state

        if (busy) {
            return
        }
        this.setState({ busy: true })
        cancel(this.props.token, confirm.id).then((response) => {
            this.setState({ busy: false })
            if (response && (response.status === 204 || response.status === 200)) {
                this.setState({ confirm: null, items: this.state.items.filter((item) => item.id !== confirm.id) })
                this._toast("Запись отменена")
            }
        })
    }

    _call = () => {
        window.location.href = "tel:+77071385100"
    }

    _map = (booking) => {
        if (booking.lat && booking.lng) {
            window.open(`https://yandex.ru/maps/?ll=${booking.lng},${booking.lat}&z=16&pt=${booking.lng},${booking.lat},pm2rdm`, "_blank", "noopener")
        }
        else {
            window.open(`https://yandex.ru/maps/?text=${encodeURIComponent(`${booking.organizationName} ${booking.addr}`)}`, "_blank", "noopener")
        }
    }

    _status = (status) => {
        if (status === "active") {
            return <span className="status status--active">{translate("Создана")}</span>
        }
        if (status === "done") {
            return <span className="status status--done">{translate("Завершена")}</span>
        }
        return <span className="status status--canceled">{translate("Отменена")}</span>
    }

    /* Draw Card */
    _card = (booking) => {
        return (
            <div key={`${booking.id}`} className="booking">
                <div className="booking-card__body" onClick={() => this._openDetail(booking)}>
                    <div className="booking-card__head">
                        <span className="booking__num">#{booking.id}</span>
                        {this._status(booking.status)}
                    </div>
                    <div className="booking__organization">{booking.organizationName}</div>
                    <div className="booking__addr">{booking.addr}</div>
                    <div className="booking__svc">
                        <span className="booking__logo"><CatIcon size={20} /></span>
                        <div>
                            <div className="booking-card__master">{booking.master}</div>
                            <div className="booking-card__svc-text">{booking.service} · {utils.duration(parseInt(booking.duration, 10))}</div>
                        </div>
                    </div>
                    <div className="booking__meta">
                        <span className="booking__meta-item"><Icon name="tag" size={16} /><span>от <b>{utils.money(booking.price)}</b></span></span>
                        <span className="booking__meta-item"><Icon name="calendar" size={16} /><span><b>{utils.time(booking.datetime)}</b> <span className="booking__date">{utils.reviewDate(booking.datetime)}</span></span></span>
                    </div>
                </div>
                <div className="booking__side">
                    <div className="booking__actions">
                        <button className="baction" onClick={() => this._call(booking)}><Icon name="phone" size={16} /><span>{translate("Связаться")}</span></button>
                        <button className="baction" onClick={() => this._map(booking)}><Icon name="map" size={16} /><span>{translate("На карте")}</span></button>
                        {booking.status === "active" && <button className="baction" onClick={() => this._openReschedule(booking)}><Icon name="clock" size={16} /><span>{translate("Изменить время")}</span></button>}
                        {booking.status === "active" && <button className="baction baction--danger" onClick={() => this._openCancel(booking)}><Icon name="trash" size={16} /><span>{translate("Отменить")}</span></button>}
                        {booking.status === "done" && <button className="baction" onClick={() => this.props.navigate(`/organization/${booking.organizationId}`)}><Icon name="chat" size={16} /><span>{translate("Оставить отзыв")}</span></button>}
                    </div>
                </div>
            </div>
        )
    }

    /* Draw Detail */
    _detail = () => {

        /* Fields */
        const { detail } = this.state

        if (!detail) {
            return null
        }
        const active = detail.status === "active"
        return (
            <div className="modal-backdrop" onClick={this._closeDetail}>
                <div className="modal modal--md" onClick={(event) => event.stopPropagation()}>
                    <div className="modal__header">
                        <h3 className="modal__title">Запись #{detail.id}</h3>
                        <button className="modal__close" onClick={this._closeDetail} aria-label="Закрыть"><Icon name="close" size={20} /></button>
                    </div>
                    <div className="modal__body">
                        <img className="booking-detail__img" src={utils.media(detail.image) || utils.FALLBACK_IMG} alt="" onError={utils.onImgError} />
                        <div className="booking-detail__row">
                            <span className="booking__num">#{detail.id}</span>
                            {this._status(detail.status)}
                        </div>
                        <div className="booking__organization">{detail.organizationName}</div>
                        <div className="booking__addr">{detail.addr}</div>
                        <div className="booking__svc">
                            <span className="booking__logo"><CatIcon size={20} /></span>
                            <div>
                                <div className="booking-card__master">{detail.master}</div>
                                <div className="booking-card__svc-text">{detail.service} · {utils.duration(parseInt(detail.duration, 10))}</div>
                            </div>
                        </div>
                        <div className="booking__meta">
                            <span className="booking__meta-item"><Icon name="tag" size={16} /><span>от <b>{utils.money(detail.price)}</b></span></span>
                            <span className="booking__meta-item"><Icon name="calendar" size={16} /><span><b>{utils.time(detail.datetime)}</b> <span className="booking__date">{utils.reviewDate(detail.datetime)}</span></span></span>
                        </div>
                        <div className="booking-detail__actions">
                            <button className="btn btn--lg" onClick={() => this._call(detail)}><Icon name="phone" size={16} /> {translate("Связаться")}</button>
                            <button className="btn btn--ghost btn--lg" onClick={() => this._map(detail)}><Icon name="map" size={16} /> Маршрут</button>
                            {active && <button className="btn btn--ghost btn--lg" onClick={() => this._openReschedule(detail)}><Icon name="clock" size={16} /> {translate("Изменить время")}</button>}
                            {active && <button className="btn btn--danger-ghost btn--lg" onClick={() => this._openCancel(detail)}><Icon name="trash" size={16} /> {translate("Отменить запись")}</button>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /* Draw Cancel */
    _cancelModal = () => {

        /* Fields */
        const { confirm, busy } = this.state

        if (!confirm) {
            return null
        }
        return (
            <div className="modal-backdrop" onClick={this._closeCancel}>
                <div className="modal modal--sm" onClick={(event) => event.stopPropagation()}>
                    <div className="modal__body">
                        <div className="booking-cancel">
                            <div className="booking-cancel__icon"><Icon name="trash" size={28} /></div>
                            <h3 className="booking-cancel__title">{translate("Отменить запись?")}</h3>
                            <p className="booking-cancel__text">Запись в «{confirm.organizationName}» на {utils.dateTime(confirm.datetime)} будет отменена. Отмена бесплатна за 3 часа до начала.</p>
                            <div className="booking-cancel__actions">
                                <button className="btn btn--ghost btn--lg" disabled={busy} onClick={this._closeCancel}>Не отменять</button>
                                <button className="btn btn--danger btn--lg" disabled={busy} onClick={this._confirmCancel}>{busy ? translate("Отменяется…") : translate("Отменить запись")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /* Draw Reschedule */
    _rescheduleModal = () => {

        /* Fields */
        const { reschedule, rescheduleDay, rescheduleTime, busy } = this.state

        if (!reschedule) {
            return null
        }
        const days = this._days()
        const selected = days[rescheduleDay]
        /* Only slots at least 6h ahead are bookable (matches the backend rule) */
        const now = new Date()
        const available = TIMES.filter((slot) => (new Date(`${selected.iso}T${slot}:00`) - now) / 3600000 >= 6)
        return (
            <div className="modal-backdrop" onClick={this._closeReschedule}>
                <div className="modal modal--lg" onClick={(event) => event.stopPropagation()}>
                    <div className="modal__header">
                        <h3 className="modal__title">{translate("Изменить время")}</h3>
                        <button className="modal__close" onClick={this._closeReschedule} aria-label="Закрыть"><Icon name="close" size={20} /></button>
                    </div>
                    <div className="modal__body reschedule__body">
                        <p className="reschedule__sub">{reschedule.organizationName} · {utils.shortDate(reschedule.datetime)}. Текущее время — <b>{utils.time(reschedule.datetime)}</b></p>

                        <div className="reschedule__label">Новый день</div>
                        <div className="reschedule__days">
                            {days.map((day, index) => (
                                <button key={day.iso} className={rescheduleDay === index ? "date is-selected" : "date"} onClick={() => this.setState({ rescheduleDay: index, rescheduleTime: null })}>
                                    <div className="date__dow">{day.dow}</div>
                                    <div className="date__day">{day.day}</div>
                                    <div className="date__mon">{day.mon}</div>
                                </button>
                            ))}
                        </div>

                        <div className="reschedule__label">Новое время</div>
                        {available.length === 0 && <p className="reschedule__none">На этот день нет доступного времени — выберите другой день.</p>}
                        <div className="times">
                            {available.map((slot) => (
                                <button key={slot} className={rescheduleTime === slot ? "time is-selected" : "time"} onClick={() => this.setState({ rescheduleTime: slot })}>{slot}</button>
                            ))}
                        </div>

                        <button className="btn btn--block btn--lg reschedule__save" disabled={!rescheduleTime || busy} onClick={this._saveReschedule}>
                            {busy ? "Сохранение…" : `Сохранить${rescheduleTime ? ` · ${selected.day} ${selected.mon}, ${rescheduleTime}` : ""}`}
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { loading, error, tab, items, toast } = this.state

        return (
            <Account active="bookings">
                <div className="content">
                    <h2 className="content__title">{translate("Мои записи")}</h2>
                    <p className="content__subtitle">{translate("Управляйте предстоящими и прошедшими записями")}</p>

                    <div className="tabs">
                        <button className={tab === "active" ? "tab is-active" : "tab"} onClick={() => this._tab("active")}>{translate("Активные")}</button>
                        <button className={tab === "history" ? "tab is-active" : "tab"} onClick={() => this._tab("history")}>{translate("История")}</button>
                    </div>

                    {loading && <Loading inline />}
                    {!loading && error && <Network onRetry={this.load} />}
                    {!loading && !error && items.length === 0 && (
                        <div className="empty">
                            <div className="empty__art"><Icon name="calendar" size={48} /></div>
                            <h3>Нет записей</h3>
                            <p>Запишитесь в организацию — записи появятся здесь.</p>
                            <button className="btn" onClick={() => this.props.navigate("/")}>Найти услугу</button>
                        </div>
                    )}
                    {!loading && !error && items.length > 0 && (
                        <div className="bookings__list">
                            {items.map((booking) => this._card(booking))}
                        </div>
                    )}
                </div>

                {this._detail()}
                {this._cancelModal()}
                {this._rescheduleModal()}

                {toast && (
                    <div className="toast">
                        <div className="toast__check"><Icon name="check" size={16} /></div>
                        <div>{toast}</div>
                    </div>
                )}
            </Account>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        token: state.token,
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(withRouter(Bookings))
